// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__39VWc","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__39OlJ"};